import React from 'react';
import { Card } from './ui/card';

const Commandments = () => {
  const commandments = [
    "Tu respecteras le consentement, toujours et partout. Le 'non' est sacré, et le respect, non négociable.",
    "Tu ne critiqueras point, tu ne jugeras point, tu ne te moqueras point. Ici, on célèbre la différence, pas le commérage.",
    "Tu honoreras ton corps et ta liberté. Tu danseras, flirteras ou jouiras comme bon te semble — sans jamais te justifier.",
    "Tu laisseras ce qui te pèse un peu derrière toi — ici, on voyage léger, bagages émotionnels inclus.",
    "Tu viendras pour t'amuser, pas pour faire la morale. La bonne vibe est obligatoire, le jugement interdit.",
    "Tu laisseras tes dramas et embrouilles à la douane. Ce séjour est une zone sans stress, sans tension, sans négativité.",
    "Tu laisseras ce qui te pèse un peu derrière toi — ici, on voyage léger, bagages émotionnels inclus.",
    "Tu accueilleras les sourires, les compliments et les rencontres avec ouverture et légèreté. Ici, on se connecte sans prise de tête.",
    "Tu prendras soin de toi et des autres. Un mot doux ou un coup de main, ça ne coûte rien et ça change tout.",
    "Tu lâcheras prise. Tu danseras, tu riras, tu vivras — car ce voyage est une parenthèse de liberté, pas une séance de psy."
  ];

  return (
    <section className="py-24 bg-gradient-to-b from-charcoal to-charcoal-light text-white">
      <div className="max-w-6xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-5xl font-light mb-6">
            Les <span className="font-semibold text-gold-300">10 Commandements</span>
          </h2>
          <div className="w-24 h-1 bg-gradient-to-r from-gold-300 to-gold-400 mx-auto mb-8"></div>
          <p className="text-xl font-light text-gray-300 max-w-2xl mx-auto">
            Pour une expérience harmonieuse et respectueuse pour toutes
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-6">
          {commandments.map((commandment, index) => (
            <Card key={index} className="p-6 bg-white/5 backdrop-blur-sm border-white/10 hover:bg-white/10 transition-all duration-300 hover:scale-105">
              <div className="flex items-start gap-4">
                <div className="flex-shrink-0 w-10 h-10 bg-gradient-to-br from-gold-300 to-gold-400 rounded-full flex items-center justify-center font-semibold text-gray-900">
                  {index + 1}
                </div>
                <p className="text-gray-100 font-light leading-relaxed pt-1">{commandment}</p>
              </div>
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Commandments;